module.exports = __webpack_public_path__ + "8ffb243fd5351444af894f75415fbf16.svg";